import { onlineManager } from '@tanstack/react-query';
import { handlerApiError } from '../../../lib/basicRepository';
import { orderProductPacksRepositoryOfflineAdapters } from '../../../modules/offline/offlineRequestAdapters/orderProductPacks.repository.offlineAdapters';
import { IPackToUpdate } from '../../../modules/orders/products/product/grid/components/packsMenu/types/useHandleOrderProductPacks.types';
import { restApi } from '../../api';
import {
  OrderProductPacksRepositoryProps,
  UpdatePacksBody,
  UpdatePacksResponse,
} from './order-product-packs.types';

export const orderProductPacksRepositoryOnline = ({
  orderId,
  productColorId,
  availability,
  deliveryWindowId,
}: OrderProductPacksRepositoryProps) => {
  const updatePacks = async (selectedPacks: IPackToUpdate[]) => {
    const body: UpdatePacksBody = { availability, packs: selectedPacks, deliveryWindowId };
    return handlerApiError<UpdatePacksResponse>(
      await restApi.post(`orders/${orderId}/order-products/${productColorId}/pack-list`, body),
    );
  };

  return { updatePacks };
};

export default (params: OrderProductPacksRepositoryProps) =>
  onlineManager.isOnline()
    ? orderProductPacksRepositoryOnline(params)
    : orderProductPacksRepositoryOfflineAdapters(params);
